import { render, staticRenderFns } from "./editAgree.vue?vue&type=template&id=2a1c7134&scoped=true&"
import script from "./editAgree.vue?vue&type=script&lang=js&"
export * from "./editAgree.vue?vue&type=script&lang=js&"
import style0 from "./editAgree.vue?vue&type=style&index=0&id=2a1c7134&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c7134",
  null
  
)

export default component.exports